import { datadogRum } from '@datadog/browser-rum';
import { User as DatadogRumUser } from "@datadog/browser-core"
import { MeDto, UserPropertiesDto, UserTypeDto } from 'Models';
import { I18n } from 'Locales/I18nService';

export const DatadogWrapper = { RUM: datadogRum };

export const toDatadogRumUser = (user: MeDto): DatadogRumUser => {

    const toUser = (user: UserPropertiesDto, customIntlKey?: string): DatadogRumUser => {
        return {
            id: user?.id,
            email: user?.email,
            last_name: user?.last_name,
            first_name: user?.first_name,
            name: I18n.format(customIntlKey ?? 'COMMON_USER_FULLNAME', { firstName: user?.first_name, lastName: user?.last_name }),
        }
    }

    switch (user?.type) {
        case UserTypeDto.Customer:
            return toUser(user.customer_properties!);
        case UserTypeDto.StmacStore:
            const store = user.stmac_store_properties;
            return { store_id: store?.id, ...toUser(store?.as_customer!) };
        case UserTypeDto.BoUserAsStore:
            return toUser(user.bo_user_as_store_properties!, 'TEST_STORE_USER_FULLNAME');
        case UserTypeDto.BoUserAsCustomer:
            return toUser(user.bo_user_as_customer_properties!, 'TEST_CUSTOMER_USER_FULLNAME');
        default:
            return {};
    }
}

